import { FunnelVO } from './../../interfaces/vo/PlanForecastBluePrintVO';
import { Component, OnInit } from '@angular/core';
import { ICollapsibleNavItemProps } from '@amobee/component-library';
import { PlannerDashboardType } from '../../enums/PlannerDashboardType.enum';
import { ActivatedRoute, Router } from '@angular/router';
import { PlannerEndpoints } from '../../constants/planner-endpoints.const'
import { AutoCompleteMappedItem } from '../../../common/components/auto-complete/auto-complete.component';
import * as _ from 'lodash';
import { ListActionsService } from '../../services/list-actions.service';
import { ModalService } from 'src/app/services/modal.service';
import { PlanStatus } from 'src/app/planner/components/planner-edit/constants/PlanStatus.const'
import { OverallPerformanceForecastVO } from '../../interfaces/vo/OverallPerformanceForecastVO';
import { CampaignPreviewVO } from '../../interfaces/vo/CampaignPreviewVO';
import { PlanConfigVO } from '../../interfaces/vo/PlanConfigVO';
import { GoalForeCastResultVO } from '../../interfaces/vo/GoalForeCastResultVO';
import { InventorySourceAllocationVO } from '../../interfaces/InventorySourceAllocationVO';
import { DealInvSrcAllocationResultVO } from '../../interfaces/vo/DealInvSrcAllocationResultVO ';
import { InvSrcAllocationResultVO } from '../../interfaces/vo/InvSrcAllocationResultVO ';

@Component({
  selector: 'planner-dashboard',
  templateUrl: './planner-dashboard.component.html',
  styleUrls: ['./planner-dashboard.component.scss']
})
export class PlannerDashboardComponent implements OnInit {

  public collapsibleItems: ICollapsibleNavItemProps[] = [];
  public currentDashBoardType: string;

  public planDetails: PlanConfigVO;
  overallPerformanceForecastData: OverallPerformanceForecastVO;
  goalPerformanceForeCastData: GoalForeCastResultVO;
  total: InventorySourceAllocationVO;
  openAuction: InvSrcAllocationResultVO;
  guaranteedDeals: InvSrcAllocationResultVO;
  privateDeals: DealInvSrcAllocationResultVO;
  generatedDate: any;
  ioPreviewData: CampaignPreviewVO;
  plannerDashboardType: any = PlannerDashboardType;
  planStatus: any = PlanStatus;
  waitingForActivation: boolean = false;
  funnelData: FunnelVO;

  public autoCompletetConfig = {
    plannerEndpoint: PlannerEndpoints.planConfigList,
    handleOnPlannerSelect: (item: AutoCompleteMappedItem) => {
      this.router.navigate(['planner-dashboard', item.value, this.currentDashBoardType]);
    },
    responseMapper: (response: any, offset: number, limit: number) => {
      let items: AutoCompleteMappedItem[] = [];
      if (response.results) {
        items = response.results.map((item) => {
          return {
            label: item.name + ' (' + item.planId + ')',
            value: item.planId
          }
        });
      }
      let hasMore = response.count && response.count > offset + limit;
      return {
        results: items,
        hasMore: !!hasMore
      }
    }
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private listActionService: ListActionsService,
    private modal: ModalService
  ) { }

  ngOnInit() {
    // should be digital-video / insertion-order-preview
    this.currentDashBoardType = this.route.snapshot.url[0].path;
    this.collapsibleItems = [
      {
        icon: 'ChannelVideo',
        label: 'Digital Video',
        title: 'Digital Video',
        active: this.currentDashBoardType == PlannerDashboardType.DigitalVideo,
        linkProps: {
          onClick: () => {
            this.router.navigate(['..', PlannerDashboardType.DigitalVideo], { relativeTo: this.route });
          }
        }
      },
      {
        icon: 'ProductCampaigns',
        label: 'Insertion Order Preview',
        title: 'Insertion Order Preview',
        active: this.currentDashBoardType == PlannerDashboardType.IOPreview,
        linkProps: {
          onClick: () => {
            this.router.navigate(['..', PlannerDashboardType.IOPreview], { relativeTo: this.route });
          }
        }
      },
    ];
    this.planDetails = this.route.snapshot.data.planDetails;
    // We can decide which filters to apply on the auto complete endpoint, marketId? advertiserId?
    this.autoCompletetConfig.plannerEndpoint = PlannerEndpoints.planConfigList +
      '?advertiserId=' + this.planDetails.advertiserId + '&marketId=' + this.planDetails.marketId;
    let data = this.route.snapshot.data.planResult[0];
    this.funnelData = this.route.snapshot.data.planResult[1];
    this.overallPerformanceForecastData = data.digitalVideo.overallPerformanceForecast;
    this.openAuction = data.digitalVideo.inventoryAllocation.openAuction;
    this.privateDeals = data.digitalVideo.inventoryAllocation.privateDeals;
    this.total = data.digitalVideo.inventoryAllocation.total;
    this.guaranteedDeals = data.digitalVideo.inventoryAllocation.guaranteedDeals;
    this.ioPreviewData = data.digitalVideo.campaignPreview;
    this.goalPerformanceForeCastData = data.digitalVideo.goalForeCastVO;
    this.generatedDate = data.createdDate;
  }

  copyAction() {
    this.modal.confirmation({ message: 'Are you sure you want to copy the selected plan?' },
      () => {
        this.listActionService.duplicate(this.planDetails.id, this.planDetails.advertiserId, this.planDetails.marketId);
      }
    )
  }

}
